import { Helmet } from "react-helmet-async";

const SITE_URL = "https://stationerywalaa.com";
const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_luxury-afford/artifacts/h2jytaqw_WhatsApp%20Image%202026-04-25%20at%2018.06.24%20%284%29.jpeg";

/**
 * Per-route SEO component.
 *
 *  <PageSEO
 *    title="Luggage Tags | Stationery Wala"
 *    description="..."
 *    path="/services"
 *    image="https://..."
 *    jsonLd={[{ '@context': 'https://schema.org', '@type': 'Product', ... }]}
 *  />
 *
 * Helmet automatically replaces / dedupes <title>, <meta>, <link rel=canonical>
 * and injects JSON-LD <script>. Googlebot reads the rendered HTML after JS.
 */
export default function PageSEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  jsonLd = null,
  type = "website",
}) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="StationeryWalaa" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD structured data */}
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
